export const flattenArray = (arr: any[]) => {
  return arr.reduce((prev, curr) => prev.concat(curr), []);
};

export const mapByKey = (key: string) => (res: any[]) => {
  return res.map((item) => item?.[key]);
};
